import { appSettings } from "@/appSettings";
import BaseStoreBuilder from "@/store/base/BaseStoreBuilder";

const accommodations = new BaseStoreBuilder({
  baseURL: appSettings.AccommodationBaseUrl,
  entityName: "accommodations"
})
  .get({
    path: ({ accommodationReferenceId }) => `accommodations/${appSettings.FederationId}/${accommodationReferenceId}/inspection-summary`,
  }, 'accommodationInspectionSummary', [])
  .build();

export default accommodations;
